import React, { useState, useEffect } from 'react';
import './App.css';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import 'animate.css';
import { Provider } from "react-redux";
import Header from './component/header/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import MovieList from './component/movieList/movieList';
import Search from './component/search/Search';
import { getDatabase, set, ref } from "firebase/database";
import Genre from "./component/search/Genre"
import { app } from "./firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./component/login/Login";
import Contact from "./component/contact/Contact";
import AboutUs from "./component/aboutus/Aboutus";
import Admin from "./component/Admin/admin";
import Animation from "./component/Watch/Animation";
import Viewmessages from "./component/viewmessages/Viewmessages"
import Signup from "./signup/Signup";
import Home from "./home/home";
import Fetch from "./component/fetch"
import Movie from "./component/moviedetails/movie";
import store from "./component/search/store";
import Movies from "./component/search/Movies";
import Mov from "./component/moviedetails/mov";
import Releaseyear from "./component/search/Releaseyear"
import FavoriteList  from "./component/favoritelist/favoritelist";
import Footer from "./component/Footer/Footer";
import Recomd from "./component/Recommend/Recommend";
import Viewhistory from "./component/viewhistory/viewhistory";
import Userssearchhistory from "../src/userhistory/userhistory";
import FavGraph from "./component/Graph/graph";
import MovieFilter from "./component/search/gen_releaseyear";
import Recommendation from "./component/Recommendation/recommendation";
import Watchlist from "./component/Watch/watchlist";
import Recent from "./component/Recommendation/recent";
import WatchlistAndAnimation from "./component/Watch/watchlist";
import Termandprivacy from "./component/Termsandprivacy/termandprivacy";
const auth = getAuth(app);

function App() {
    const [user, setUser] = useState(null);
    const [theme, setTheme] = useState('dark'); // Default theme is dark
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [allFavorites, setAllFavorites] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleLogin = (loggedInUser) => {
        setUser(loggedInUser);
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (loggedInUser) => {
            setUser(loggedInUser);
            setIsLoading(false); // Set loading to false after authentication check
        });

        // Simulate loading with a delay (remove this in production)
        setTimeout(() => {
            setIsLoading(false); // Set loading to false after 2 seconds
        }, 2000);

        return () => {
            unsubscribe();
        };
    }, []);

    const toggleTheme = () => {
        setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    return (
        <div className={`App ${theme}`}>
            <Provider store={store}>
                <Router>
                    <Header toggleTheme={toggleTheme} />
                    <Routes>
                        <Route
                            path="/"
                            element={
                                user ? (
                                    <Navigate to="/home" />
                                ) : (
                                    <Signup theme={theme} toggleTheme={toggleTheme} />
                                )
                            }
                        />
                        <Route path="/login" element={<Login theme={theme} toggleTheme={toggleTheme} />} />
                        <Route path="/signup" element={<Signup theme={theme} toggleTheme={toggleTheme} />} />


                        {user ? (
                            <>
                                <Route path="/home" element={<Home />} />
                                <Route path="/search" element={<Search theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/:mediaType/:mediaId" element={<Movies  theme={theme} toggleTheme={toggleTheme}/>} />
                                <Route path="movie/:id" element={<Movie  theme={theme} toggleTheme={toggleTheme}/>} />
                                <Route path="/movies/:genre" component={Genre}  theme={theme} toggleTheme={toggleTheme}/>
                                <Route path="tv/:id" element={<Mov  theme={theme} toggleTheme={toggleTheme}/>} />
                                <Route path="/genre" element={<Genre theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/releaseyear" element={<Releaseyear theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/favoritelist" element={<FavoriteList setError={setError} setLoading={setLoading} setAllFavorites={setAllFavorites} />} />
                                <Route path="movie/:type" element={<MovieList />} />
                                <Route path="/aboutus" element={<AboutUs theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/Viewmessages" element={<Viewmessages theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/viewhistory" element={<Viewhistory theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/userhistory" element={<Userssearchhistory theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/login" element={<Login theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/contact" element={<Contact theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/admin" element={<Admin theme={theme} toggleTheme={toggleTheme}/>} />
                                <Route path="/Recomd" element={<Recomd />} />
                                <Route path="/recommendation" element={<Recommendation theme={theme} toggleTheme={toggleTheme}/>} />
                                <Route path="/recent" element={<Recent/>}/>
                                <Route path="/fetch" element={<Fetch />} />
                                <Route path="/graph" element={<FavGraph theme={theme} toggleTheme={toggleTheme}/>}/>
                                <Route path="/gen_releaseyear" element={<MovieFilter/>}/>
                                <Route path="/watchlist" element={< WatchlistAndAnimation theme={theme} toggleTheme={toggleTheme} />}/>
                                <Route path="/Animation" element={<Animation />}/>
                                <Route path="/signup" element={<Signup theme={theme} toggleTheme={toggleTheme} />} />
                                <Route path="/termandprivacy" element={<Termandprivacy theme={theme} toggleTheme={toggleTheme} />} />

                            </>
                        ) : (
                            <>
                            // <Route path="/Signup" element={<Signup theme={theme} toggleTheme={toggleTheme} />} />
                            <Route path="/login" element={<Navigate to="/login" theme={theme} toggleTheme={toggleTheme}  />} />
                            </>
                )}
                    </Routes>
                    <Footer theme={theme} toggleTheme={toggleTheme}/>


                </Router>

            </Provider>
        </div>
    );
}

export default App;